import * as firebaseApp from 'firebase';

  const firebaseConfig = {
    apiKey: "AIzaSyAlrK05U36c6hk8arR19EYUuupXichjlbY",
    authDomain: "araapp-90f11.firebaseapp.com",
    databaseURL: "https://araapp-90f11.firebaseio.com",
    projectId: "araapp-90f11",
    storageBucket: "araapp-90f11.appspot.com",
    messagingSenderId: "918864630590",
    appId: "1:918864630590:web:1d4e4668111027d6ab526f",
    measurementId: "G-V1J6KB8FHT"
  };

firebaseApp.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
export const createWeb = async(data, into) => {
  const createdAt = new Date();
  data.createdAt = createdAt;
 const response = await db.collection(into)
  .add(data)
  .then(() => {
    return true;
  })
  return response;
};

export const getData = async(from) => {
  const list = [];
  const response = await db.collection(from).orderBy("createdAt", "asc")
  .get()

  response.forEach(value => {
      const item = value.data();
      item.id = value.id
      list.push(item);      
  })
  return list;
  
}


export default firebaseApp;